// Central content + real project imagery from the original Fresh Landscaping site.
const CDN = "https://img1.wsimg.com/isteam/ip/d07bfedb-a809-4171-963c-4160a6fc5620/";

// Build a resized CDN url from an original filename.
export const cdn = (file, w = 1400, h = 1000) =>
  `${CDN}${encodeURIComponent(file)}/:/rs=w:${w},h:${h},cg:true`;

// Real hardscaping / project photos from the original site.
export const galleryImages = [
  cdn("5aa57cea-bfed-4db1-9291-e0ab08b73788.jpg"),
  cdn("4045b7dc-7051-4ca4-ac99-49795ef909b7.jpg"),
  cdn("faffad43-6aab-4084-958f-094e2b39ec4b.jpg"),
  cdn("IMG_9003.jpeg"),
  cdn("(Upload-from-mobile-1772732963)IMG_9011.jpeg"),
  cdn("(Upload-from-mobile-1772732963)IMG_9009.jpeg"),
  cdn("IMG_9002.jpeg"),
  cdn("(Upload-from-mobile-1772732963)IMG_9010.jpeg"),
  cdn("(Upload-from-mobile-1772727798)IMG_8992.jpeg"),
  cdn("(Upload-from-mobile-1772727856)IMG_8993.jpeg"),
  cdn("(Upload-from-mobile-1772727798)IMG_8995.jpeg"),
  cdn("(Upload-from-mobile-1772727798)IMG_8994.jpeg"),
];

export const snowImages = {
  trucks: cdn("blob-6aa9453.png", 1600, 900),
  plow: cdn("IMG_9015.jpeg", 1200, 1200),
  clearing: cdn("blob-919be13.png", 1600, 900),
};

export const kitchenImage = cdn("1e61791e-b682-4dfe-94a5-c5c058b4997c.jpg", 1600, 1100);

// Real lawn maintenance photos (owner-provided).
const A = "https://customer-assets.emergentagent.com/job_fresh-modern/artifacts";
export const lawnImages = [
  `${A}/8ne3fwpd_IMG_9764.jpeg`,
  `${A}/8s1613ab_IMG_9765.jpeg`,
  `${A}/c389jqm4_IMG_9769.jpeg`,
  `${A}/dqu53c5g_IMG_9770.jpeg`,
];

// Premium supplementary images (original hero/lawn images were access-protected).
export const stock = {
  hero: "https://static.prod-images.emergentagent.com/jobs/95b3b1c3-d365-416b-acdd-3d42607f2996/images/3ca8a306571cdb168686fad96cb9b4e292cf6250d96cb6fb7dada607efd4e4f2.png",
  lawn: "https://images.pexels.com/photos/4469146/pexels-photo-4469146.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  mowing: "https://images.pexels.com/photos/13630739/pexels-photo-13630739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  lawnClose: "https://images.unsplash.com/photo-1458245201577-fc8a130b8829?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  patio: "https://images.unsplash.com/photo-1775733923991-e7223f9f44bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const company = {
  name: "Fresh Landscape Group",
  short: "Fresh Landscaping",
  logo: "/fresh-logo.png",
  tagline: "Transforming outdoor spaces with quality care.",
  phone: "(587)-216-4078",
  phoneHref: "tel:5872164078",
  location: "Airdrie, Alberta, Canada",
  social: {
    facebook: "https://www.facebook.com/freshlandscapingalberta",
    instagram: "https://www.instagram.com/freshlandscapealberta/",
    tiktok: "https://www.tiktok.com/@freshlandscaping",
  },
};

export const story =
  "At Fresh Landscaping, we specialize in creating outdoor spaces that are both beautiful and built to last. Our team provides full-service landscaping and hardscaping design, installation, and maintenance — from lawn care, planting, and garden design to custom patios, walkways, retaining walls, decks, and fences. We also offer full-service snow removal to keep properties safe and accessible throughout the winter, including residential snow clearing, commercial snow removal, plowing for driveways and parking lots, and sanding to improve traction during icy conditions. With reliable equipment and a hardworking team, we are committed to keeping your property well maintained, functional, and safe in every season.";

export const services = [
  {
    slug: "hardscaping",
    title: "Hardscaping",
    icon: "Grid3x3",
    blurb: "Custom patios, walkways, retaining walls, decks and fences built to last.",
    image: cdn("4045b7dc-7051-4ca4-ac99-49795ef909b7.jpg", 1200, 1500),
  },
  {
    slug: "snow-removal",
    title: "Snow Removal",
    icon: "Snowflake",
    blurb: "Residential & commercial clearing, plowing and sanding all winter long.",
    image: snowImages.trucks,
  },
  {
    slug: "lawn-maintenance",
    title: "Lawn Maintenance",
    icon: "Sprout",
    blurb: "Lawn care, planting and garden design that keeps your property pristine.",
    image: lawnImages[0],
  },
  {
    slug: "outdoor-kitchens",
    title: "Outdoor Kitchens",
    icon: "ChefHat",
    blurb: "Custom-designed, climate-ready outdoor kitchens for entertaining.",
    image: kitchenImage,
  },
];

// Real customer reviews (word-for-word from the owner's previous site / Facebook recommendations).
export const testimonials = [
  {
    name: "Tracy Johnson",
    date: "July 25, 2025",
    rating: 5,
    quote:
      "What a great local company. I picked Fresh Landscaping based on the reviews and after meeting with them decided to put our trust in them to transform our yard. The original landscaping was starting to crumble, the rock and retaining wall were deteriorating to the point where the yard was unsafe and not usable. The crew at Fresh Landscaping spent so much time clearing out the old materials to make sure everything was done right and they are meticulous about their work.\n\nI can’t say enough about this crew. The hours of hard work they put in. Engaging with us every step of the way. Each of them always friendly and smiling. You can tell this team genuinely enjoys what they do and working together.\n\nThe project came in on time and on budget. Truly amazing given the weather we had. Greg knows how to get it done.\n\nCompletely happy with our selection of Fresh Landscaping. Highly recommend!",
  },
  {
    name: "Brooke Rachel",
    date: "September 26, 2025",
    rating: 5,
    quote:
      "Fresh Landscaping was great to deal with for a large window well/retainer wall repair that other local contractors declined the project on because of its complexities. Dave made the entire process simple, completed the project on time and even slightly under budget. I'm very happy with the work done and would use them again without hesitation.",
  },
  {
    name: "Pao Mejia",
    date: "July 8, 2025",
    rating: 5,
    quote:
      "We had an amazing experience with Fresh Landscaping! They worked on both our front and backyard, and we absolutely love how everything turned out.\n\nThey first completed our backyard and part of the front yard last year, and came back this year to finish the remaining front section once our neighbors finished building and the ground was ready. The entire process was seamless and the results speak for themselves—beautiful, high-quality work!\n\nDave, and the entire crew are incredibly talented, professional, and easy to work with. Communication was great throughout, and they were always available when we needed them. We had a small issue come up due to house settling, and they came out promptly to take care of it—no questions asked.\n\nWe couldn’t recommend Fresh Landscaping enough. If you’re looking for a team that’s skilled, reliable, and takes pride in their work, these are your people!",
  },
];
